import { DiagnosisItemButtonProps } from 'models/Common/buttonTypes';
import styled from 'styled-components';
import { BorderColor, PrimaryColor, TextColor } from 'styles/Global/colorSemantic';
import { font, palette } from 'styles/Global/globalStyles';
import { Body2BoldButton, Body4SemiBoldButton } from 'styles/Global/typography';

interface TapProps {
    children?: React.ReactNode;
    $idx?: number;
    $selected?: number;
    $count?: number;
    onClick?: () => void;
}

export const Tap = ({ children, $idx, $selected, $count, onClick }: TapProps) => {
    return (
        <DiagnosisItemButton $idx={$idx} $selected={$selected} $count={$count} onClick={onClick}>
            {children}
        </DiagnosisItemButton>
    );
};

const DiagnosisItemButton = styled(Body4SemiBoldButton)<TapProps>`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: calc(100% / ${(props) => props.$count});
    height: 100%;
    margin-top: auto;
    gap: 4px;

    font-weight: ${(props) => (props.$idx === props.$selected ? font.weight.bold : font.weight.semiBold)};
    color: ${(props) => (props.$idx === props.$selected ? PrimaryColor.color_primary_strong : TextColor.color_text_weak)};
    padding: 12px 20px;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${(props) => (props.$idx === props.$selected ? '2px' : '1px')};
        background-color: ${(props) => (props.$idx === props.$selected ? PrimaryColor.color_primary_strong : BorderColor.color_border_normal)};
    }

    &:disabled {
        color: ${palette.testGray};
        border: none;
        background-color: transparent;
    }
`;
